import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { updateReview } from '../../Apis';


export const SubmitReview = createAsyncThunk('SubmitReview', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await updateReview(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});


const reviewSlice = createSlice({
    name: 'review',
    initialState: {
        error: null,
        success: false,
    },
    reducers: {
        clearReviewStatus: state => {
            state.success = false;
            state.error = null;
        }
    },
    extraReducers: builder => {
        builder
            // gett
            .addCase(SubmitReview.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(SubmitReview.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
            })
            .addCase(SubmitReview.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
    },

});
export const { clearReviewStatus } = reviewSlice.actions;
export default reviewSlice.reducer;

